import React from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  Box,
  Modal,
  Button,
  Card,
  Heading,
  Input,
  useToast,
} from '@chakra-ui/react';

import xhr from 'xhr';

import * as Yup from 'yup';
import { useParams } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';
import dayjs from 'dayjs';

import useAuth from 'hooks/useAuth';
import BasicModal from 'components/modal/Modal';
import { Textarea } from '@chakra-ui/react';
import { EmptyState } from '../../components/ui';

export default function HistorialTable() {
  const params = useParams();
  const id_est = params.id;
  const [historyProspect, setHistoryProspect] = React.useState([]);

  const { user } = useAuth();
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    const getHistoryProspect = async () => {
      try {
        const res2 = await xhr(`/prospect-histories?filters[prospect][id][$eq]=${params.id}&populate=*&sort[0]=createdAt:desc`);
        setHistoryProspect(res2.data.data);
      } catch (error) {
        console.error(error);
      }
    };
    getHistoryProspect();
  }, []);

  const BasicInfoSchema = Yup.object().shape({
    detail: Yup.string().required('Requerido'),
  });

  const [loading, setLoading] = React.useState(false);
  const toasts = useToast();

  const handleTopic2 = async (values, action) => {
    try {
      setLoading(true);

      const response = await xhr.post(`/prospect-histories/`, {
        data: {
          ...values,
          prospect: id_est,
          user: user.id,
        },
      });
      const getPopulate = await xhr(`prospect-histories/${response.data.data.id}?populate=*`);

      setHistoryProspect([getPopulate.data.data, ...historyProspect]);

      toasts({
        title: 'El historial se creo correctamente',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      setIsOpen(false);
      action.resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box marginBottom="15px">
        <Button size="sm" variant="outline" colorScheme="purple" onClick={() => setIsOpen(true)}>
          + Historial
        </Button>
        <BasicModal isOpen={isOpen} setIsOpen={setIsOpen}>
          <Box>
            <Formik
              initialValues={{
                detail: '',
              }}
              validationSchema={BasicInfoSchema}
              onSubmit={handleTopic2}
            >
              <Form>
                <Heading as="h2" fontSize="lg" margin="0">
                  Nuevo registro de historial
                </Heading>
                <Field
                  marginTop="20px"
                  name="detail"
                  label="Detalle"
                  color="black"
                  rows={4}
                  placeholder="Qué pasó en el contacto: llamada, mensaje, acuerdos…"
                  as={Textarea}
                />

                <Button type="submit" colorScheme="purple" marginTop="15px" width="100%" isLoading={loading}>
                  Guardar registro
                </Button>
              </Form>
            </Formik>
          </Box>
        </BasicModal>
      </Box>
      {historyProspect.length === 0 ? (
        <EmptyState
          title="Este prospecto aún no tiene historial"
          description="Registra cada contacto para que quede la evidencia del seguimiento."
        />
      ) : (
        <TableContainer>
          <Table size="sm">
            <Thead>
              <Tr>
                <Th>Detalle</Th>
                <Th>Registrado por</Th>
                <Th textAlign="right">Fecha</Th>
              </Tr>
            </Thead>
            <Tbody>
              {historyProspect.map((requi) => (
                <Tr key={requi.id}>
                  <Td whiteSpace="pre-wrap" py={3}>
                    {requi.detail}
                  </Td>
                  <Td>{requi.user && `${requi.user.first_name} ${requi.user.last_name}`}</Td>
                  <Td textAlign="right" whiteSpace="nowrap">
                    {dayjs(requi.createdAt).format('DD/MM/YYYY hh:mm A')}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
